import { render } from "./LoneTacchiato.vue?vue&type=template&id=33cd9d8d"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/LoneTacchiato.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33cd9d8d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33cd9d8d', __exports__)) {
    api.reload('33cd9d8d', __exports__)
  }
  
  module.hot.accept("./LoneTacchiato.vue?vue&type=template&id=33cd9d8d", () => {
    api.rerender('33cd9d8d', render)
  })

}


export default __exports__